import { z } from 'zod';
import { competitionCodeSchema, competitionTierSchema, coverageRateSchema, coverageVerdictSchema, qualityScoreSchema, } from './international-competition.js';
import { researchSeasonSchema } from './worldcup-research.js';
const nonEmptyStringSchema = z.string().trim().min(1);
const nonNegativeIntSchema = z.number().int().min(0);
const qualityScoreQuerySchema = z.coerce.number().pipe(qualityScoreSchema);
const booleanQuerySchema = z.union([
    z.boolean(),
    z.literal('true').transform(() => true),
    z.literal('false').transform(() => false),
]);
export const researchViewSchema = z.enum([
    'major_tournament',
    'competitive_context',
    'exploratory_all',
]);
export const researchViewCompetitionCodes = {
    major_tournament: ['world_cup', 'euro', 'copa_america'],
    competitive_context: ['world_cup', 'euro', 'copa_america', 'nations_league', 'world_cup_qualifier'],
    exploratory_all: ['world_cup', 'euro', 'copa_america', 'nations_league', 'world_cup_qualifier', 'friendlies'],
};
export const internationalResearchSeasonSchema = z.union([
    researchSeasonSchema,
    z.number().int().min(2015).max(2030),
]);
export const competitionAwareResearchQuerySchema = z.object({
    competitionCode: competitionCodeSchema.optional(),
    competitionTier: competitionTierSchema.optional(),
    researchView: researchViewSchema.default('major_tournament'),
    season: z.coerce.number().pipe(internationalResearchSeasonSchema).optional(),
    team: nonEmptyStringSchema.optional(),
    opponent: nonEmptyStringSchema.optional(),
    provider: nonEmptyStringSchema.optional(),
    minDataQualityScore: qualityScoreQuerySchema.default(0.65),
    includeSingleProvider: booleanQuerySchema.default(true),
    includeFriendlies: booleanQuerySchema.default(false),
});
export const competitionCoverageFieldFamilySchema = z.enum([
    'fixture_statistics',
    'lineups',
    'player_statistics',
    'scores',
]);
export const competitionCoverageRegistryRowSchema = z.object({
    importBatchId: nonEmptyStringSchema.optional(),
    competitionCode: competitionCodeSchema,
    competitionName: nonEmptyStringSchema,
    season: z.coerce.number().pipe(internationalResearchSeasonSchema),
    provider: nonEmptyStringSchema,
    fieldFamily: competitionCoverageFieldFamilySchema,
    fixtureCoverageRate: coverageRateSchema,
    scoreCoverageRate: coverageRateSchema,
    totalShotCoverageRate: coverageRateSchema,
    shotsOnGoalCoverageRate: coverageRateSchema,
    cornerCoverageRate: coverageRateSchema,
    xgCoverageRate: coverageRateSchema,
    lineupCoverageRate: coverageRateSchema,
    playerStatCoverageRate: coverageRateSchema,
    fixturesChecked: nonNegativeIntSchema,
    fixturesWithStats: nonNegativeIntSchema,
    dataQualityScore: qualityScoreSchema,
    recommendedWeight: qualityScoreSchema,
    verdict: coverageVerdictSchema,
    coverageCheckedAt: nonEmptyStringSchema,
    warnings: z.array(nonEmptyStringSchema).default([]),
});
export { competitionCodeSchema, competitionTierSchema };
